class ProspectUtils {
  static verifyCard(account_id, email, phone) {
    fetch(`/card_verification_check?account_id=${account_id}&email=${email}&phone=${phone}`, {headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }})
      .then(FetchUtils.checkResponseStatus)
      .then(response => response.json())
      .then(data => {
        const stripeForm = document.querySelector('.question[data-type="card"] .js-stripe-card-form');
        if (JSON.parse(data.valid)) {
          LayoutUtils.hide(document.querySelector('.question[data-type="verification_method"]')?.childNodes);
          LayoutUtils.hide(document.querySelector('.question[data-type="card"]')?.childNodes);
          document.querySelector('.question[data-type="card"]')?.insertAdjacentHTML('beforeend', '<p>Credit Card Previously Approved</p>');
          if (stripeForm) stripeForm.dataset.active = 'false';
        } else {
          LayoutUtils.show(document.querySelector('.question[data-type="verification_method"]')?.childNodes);
          LayoutUtils.show(document.querySelector('.question[data-type="card"]')?.childNodes);
          document.querySelector('.question[data-type="card"] p')?.remove();
          // Re-apply verification method selection to set data-active correctly
          const vmSelect = document.querySelector('.verification_method');
          if (vmSelect) {
            vmSelect.dispatchEvent(new Event('change'));
          } else if (stripeForm) {
            const cardQuestion = stripeForm.closest('.question[data-type="card"]');
            if (cardQuestion && window.getComputedStyle(cardQuestion).display !== 'none') {
              stripeForm.dataset.active = 'true';
            }
          }
        }
      })
      .catch(err => {
        FetchUtils.handleResponseError(err);
      });
  }
}

export default ProspectUtils;
